var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:(_vm.name + "__title")},[_vm._v("\n    "+_vm._s(_vm.$t('adgroup_pacing_standard'))+"\n  ")]),_vm._v(" "),_c('div',{class:(_vm.name + "__tips")},[_c('span',[_vm._v(_vm._s(_vm.$t('adgroup_pacing_standard_hint')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }